import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';

const SrTextSubtitle = ({
  children,
  opacity,
  weight,
}) => {
  return (
    <SrText
      font='greycliff'
      fontSize='16px'
      lineHeight='25px'
      color='blueGreycliff'
      opacity={opacity}
      weight={weight}
      letterSpacing='0px'
    >
      {children}
    </SrText>
  );
};

const SrPartnerApprovalSecurityDepositIntoText = ({ securityDepositLabel }) => {
  return (
    <>
      <SrTextSubtitle opacity={0.6} weight='500'>
        You can add a multiplier to the {securityDepositLabel} if the renters
      </SrTextSubtitle>
      <SrTextSubtitle opacity={1} weight='700'>
        {' do not fit '}
      </SrTextSubtitle>
      <SrTextSubtitle opacity={0.6} weight='500'>
        the criteria.
      </SrTextSubtitle>
    </>
  );
};

SrPartnerApprovalSecurityDepositIntoText.propTypes = {
  securityDepositLabel: PropTypes.string.isRequired,
};

SrPartnerApprovalSecurityDepositIntoText.displayName = 'SrPartnerApprovalSecurityDepositIntoText';

export default SrPartnerApprovalSecurityDepositIntoText;
